// CRITICAL: Import interceptor TRƯỚC TẤT CẢ để chặn Firebase API calls
// Phải import trước React và Firebase SDK
import './utils/firebase-interceptor';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

